export default "__VITE_ASSET__JD5UX0u5__"